import React from "react";

const ImageLightbox = ({
  images,
  selectedImage,
  setSelectedImage,
  onClose
}) => {
  return (
    <div
      className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-5xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white text-3xl"
        >
          ✕
        </button>

        {/* Main Image */}
        <img
          src={images[selectedImage]}
          className="w-full max-h-[80vh] object-contain"
          alt=""
        />

        {/* Left Arrow */}
        <button
          onClick={() =>
            setSelectedImage(
              selectedImage === 0
                ? images.length - 1
                : selectedImage - 1
            )
          }
          className="absolute left-0 top-1/2 -translate-y-1/2 text-white text-4xl px-4"
        >
          ‹
        </button>

        {/* Right Arrow */}
        <button
          onClick={() =>
            setSelectedImage(
              selectedImage === images.length - 1
                ? 0
                : selectedImage + 1
            )
          }
          className="absolute right-0 top-1/2 -translate-y-1/2 text-white text-4xl px-4"
        >
          ›
        </button>

        {/* Bottom Thumbnails */}
        <div className="flex justify-center gap-3 mt-4 overflow-x-auto">
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              onClick={() => setSelectedImage(index)}
              className={`w-16 h-16 object-cover border cursor-pointer ${
                selectedImage === index
                  ? "border-white"
                  : "border-gray-500"
              }`}
              alt=""
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageLightbox;